import moment from 'moment'

export default {
  filterOptions: () => {

    let options = [
      {
        value: 'this_year',
        label: 'Ano atual'
      },
      {
        value: 'last_two_years',
        label: 'Últimos 2 anos'
      }
    ]

    for (let i = 0; i < 12; i++) {
      let month = moment().subtract(i, 'month');
      let option = {
        value: month.format('MM/YYYY'),
        label: month.format('MM/YYYY'),
      }

      options.push(option)
    }

    for (let i = 1; i <= 2; i++) {
      let year = moment().subtract(i, 'year');
      let option = {
        value: year.format('YYYY'),
        label: year.format('YYYY'),
      }

      options.push(option)
    }

    return options
  }
}
